import type IScoreboardEntry from '../../../models/pa-egna-ben/scoreboard-entry.model';

export default class ScoreboardEntryApiModel {
  public rank!: number;
  public participationName!: string;
  public participationId!: number;
  public schoolName!: string;
  public municipalityGid!: string;
  public weightedTotalScore!: number;
  public numberOfStudents!: number;
  public completedKilometers!: number;
  public carbonDioxide!: number;

  public static mapToBusinessModel(apiModel: ScoreboardEntryApiModel): IScoreboardEntry {
    return {
      rank: apiModel.rank,
      participationName: apiModel.participationName,
      participationId: apiModel.participationId,
      schoolName: apiModel.schoolName,
      municipalityGid: apiModel.municipalityGid,
      weightedTotalScore: apiModel.weightedTotalScore,
      numberOfStudents: apiModel.numberOfStudents,
      completedKilometers: apiModel.completedKilometers,
      carbonDioxide: apiModel.carbonDioxide,
    };
  }
}
